export default __webpack_public_path__ + "static/media/3.9891e714.png";